import { render, staticRenderFns } from "./extlinkcardswd.vue?vue&type=template&id=1e65db76&scoped=true&"
import script from "./extlinkcardswd.vue?vue&type=script&lang=js&"
export * from "./extlinkcardswd.vue?vue&type=script&lang=js&"
import style0 from "./extlinkcardswd.vue?vue&type=style&index=0&id=1e65db76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65db76",
  null
  
)

export default component.exports